import React from 'react';
import { DefaultContainer, AnimationContainer } from './Icons-styled';

interface DedicatedIconProps {
  selected?: boolean;
}

const DedicatedIcon: React.FC<DedicatedIconProps> = ({ selected = false }) => {
  const svg = (
    <svg
      style={{
        fill: selected ? '#48e2cb' : '#cacaca',
        maxHeight: '64px',
        maxWidth: '64px',
        marginBottom: '2rem'
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
    >
      <path d="M47.56 24.003a.837.837 0 0 0-.478-.676l-6.955-4.174 6.956-4.174a.837.837 0 0 0 .477-.676.837.837 0 0 0-.477-.676L24.877.303a2.211 2.211 0 0 0-1.805 0L.87 13.627a.83.83 0 0 0-.477.673.839.839 0 0 0 .476.679l6.951 4.17-6.95 4.175a.718.718 0 0 0 0 1.352l6.956 4.174L.87 33.024a.714.714 0 0 0 0 1.348l22.203 13.324a2.124 2.124 0 0 0 1.805.002l22.206-13.325a.718.718 0 0 0 0-1.352l-6.952-4.175 6.95-4.17a.831.831 0 0 0 .478-.673zm-46.263-9.7L23.485.987a1.436 1.436 0 0 1 .979 0l22.19 13.316-22.19 13.315a1.451 1.451 0 0 1-.978 0zm45.358 19.394l-22.19 13.317a1.132 1.132 0 0 1-.488.084 1.103 1.103 0 0 1-.49-.086L1.3 33.698l7.301-4.381L23.072 38a2.125 2.125 0 0 0 1.806 0l14.477-8.688zm-22.19 3.618a1.451 1.451 0 0 1-.979 0L1.296 24l7.3-4.384 14.477 8.687a2.125 2.125 0 0 0 1.805 0l14.471-8.684L46.651 24z"></path>
    </svg>
  );

  return selected ? (
    <AnimationContainer>{svg}</AnimationContainer>
  ) : (
    <DefaultContainer>{svg}</DefaultContainer>
  );
};
export default DedicatedIcon;
